import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component SettingsIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <SettingsIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <SettingsIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SettingsIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="SettingsIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M4.14 16H3a1 1 0 0 0 0 2h1.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H21a1 1 0 0 0 0-2h-9.14c-.45-1.72-2-3-3.86-3s-3.41 1.28-3.86 3M6 17c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2M16 3c-1.86 0-3.41 1.28-3.86 3H3a1 1 0 1 0 0 2h9.14c.45 1.72 2 3 3.86 3s3.41-1.28 3.86-3H21a1 1 0 0 0 0-2h-1.14c-.45-1.72-2-3-3.86-3m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
      />
    </svg>
  )
);
SettingsIcon.displayName = "SettingsIcon";
export default SettingsIcon;
